<div>
  <svg-icon src='./assets/icons/close-outline.svg'
            class="menu-action-icon svg-icon-large svg-icon-red" (click)="closeApprovalHistory()" title="{{ 'raci.generalTasks.close' | translate | uppercase }}"></svg-icon>
</div>
<div class="approval-history-container">
  <div class="approval-header">
    <div class="approval-history-title">
      <h1 *ngIf="task?.taskTypeId != taskTypes.ValoremFunction">
        {{ 'raci.approvalHistory.title' | translate | uppercase }}
      </h1>
      <h1 *ngIf="task?.taskTypeId == taskTypes.ValoremFunction">
        {{ 'raci.approvalHistory.valoremTitle' | translate | uppercase }}
      </h1>
    </div>
    <div *ngIf="task?.taskTypeId != taskTypes.ValoremFunction">
      <div class="action-icon" *ngIf="groupByProjectData.length > 0" (click)="changeGroupStatus('project')">
        <svg-icon src='./assets/icons/Project_icon.svg' class="raci-icon svg-icon-gray"
                  [ngClass]="groupBy === 'project' ? 'svg-icon-red' : 'svg-icon-new'" title="{{'raci.approvalHistory.orderByProject' | translate | uppercase}}"></svg-icon>
        <div class="history-icon-label " [innerHTML]="'raci.approvalHistory.orderByProject' | translate | uppercase"></div>
      </div>
      <div class="action-icon" *ngIf="groupByPropertiesData.length > 0" (click)="changeGroupStatus('property')">
        <svg-icon src='./assets/icons/Properties_icon.svg' class="raci-icon svg-icon-gray"
                  [ngClass]="groupBy === 'property' ? 'svg-icon-red' : 'svg-icon-new'" title="{{'raci.approvalHistory.orderByProperty' | translate | uppercase}}"></svg-icon>
        <div class="history-icon-label" [innerHTML]="'raci.approvalHistory.orderByProperty' | translate | uppercase"></div>
      </div>
      <div class="action-icon" *ngIf="groupByDateData?.length > 0" (click)="changeGroupStatus('date')">
        <svg-icon src='./assets/icons/calendar-outline.svg' class="raci-icon svg-icon-gray"
                  [ngClass]="groupBy === 'date' ? 'svg-icon-red' : 'svg-icon-new'" title="{{'raci.approvalHistory.orderByDate' | translate | uppercase}}"></svg-icon>
        <div class="history-icon-label" [innerHTML]="'raci.approvalHistory.orderByDate' | translate | uppercase"></div>
      </div>
    </div>
  </div>
  <div class="scroll-box" *ngIf="groupBy === 'project' && task?.taskTypeId != taskTypes.ValoremFunction">
    <div *ngIf="groupByProjectData?.length == 0">
      {{ 'raci.approvalHistory.noDataAvailable' | translate }}
    </div>
    <div *ngFor="let approval of groupByProjectData">
      <div class="approval-group-header">
        <svg-icon src='./assets/icons/Project_icon.svg'
                  class="raci-icon svg-icon-red"></svg-icon>
        <p class="group-title">{{approval.group}} </p>
      </div>

      <div class="history-block">
        <div *ngFor="let history of approval.historyRecords; index as i;">
          <div class="history-record">
            <div class="history-left-info">
              <p>{{history.taskName}}</p>
              <p>{{history.dateOfChange | date: 'dd.MM.YYYY'}}</p>
            </div>
            <div>
              <svg-icon src='./assets/icons/checkmark-circle-outline.svg'
                        class="raci-icon raci-icon-bg-green svg-icon-white"
                        *ngIf="history.isApproved"></svg-icon>
              <svg-icon src='./assets/icons/close-circle-outline.svg'
                        class="raci-icon raci-icon-bg-red svg-icon-white" *ngIf="!history.isApproved"></svg-icon>
            </div>
            <div class="history-right-info">
              <p>{{history.userDescription}}</p>
              <p>{{history.comment}}</p>
            </div>
          </div>
          <div *ngIf="i < approval.historyRecords.length - 1" class="devide-vertical-line"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="scroll-box" *ngIf="groupBy === 'property' && task?.taskTypeId != taskTypes.ValoremFunction">
    <div *ngIf="groupByPropertiesData?.length == 0">
      {{ 'raci.approvalHistory.noDataAvailable' | translate }}
    </div>
    <div *ngFor="let approval of groupByPropertiesData">
      <div class="approval-group-header">
        <svg-icon src='./assets/icons/Properties_icon.svg'
                  class="raci-icon"
                  [ngClass]="groupStatus ? 'svg-icon-red' : 'svg-icon-new'"></svg-icon>
        <p class="group-title">{{approval.group}}</p>
      </div>
      <div class="history-block">
        <div *ngFor="let history of approval.historyRecords; index as i;">
          <div class="history-record">
            <span class="history-left-info">{{history.dateOfChange | date: 'dd.MM.YYYY'}}</span>
            <div>
              <svg-icon src='./assets/icons/checkmark-circle-outline.svg'
                        class="raci-icon raci-icon-bg-green svg-icon-white"
                        *ngIf="history.isApproved"></svg-icon>
              <svg-icon src='./assets/icons/close-circle-outline.svg'
                        class="raci-icon raci-icon-bg-red svg-icon-white" *ngIf="!history.isApproved"></svg-icon>
            </div>
            <div class="history-right-info">
              <p>{{history.userDescription}}</p>
              <p>{{history.comment}}</p>
            </div>
          </div>
          <div *ngIf="i < approval.historyRecords.length - 1" class="devide-vertical-line"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="scroll-box" *ngIf="groupBy === 'date' && task?.taskTypeId != taskTypes.ValoremFunction">
    <div *ngIf="groupByDateData?.length == 0">
      {{ 'raci.approvalHistory.noDataAvailable' | translate }}
    </div>
    <div *ngFor="let approval of groupByDateData">
      <div class="approval-group-header">
        <svg-icon src='./assets/icons/calendar-outline.svg'
                  [ngClass]="!groupStatus ? 'svg-icon-red' : 'svg-icon-new'"
                  class="raci-icon"></svg-icon>
        <div class="group-title">
          <span>
            {{approval.group | date: 'dd.MM.YYYY'}}
          </span>
        </div>
      </div>
      <div class="history-block">
        <div *ngFor="let history of approval.historyRecords; index as i;">
          <div class="history-record">
            <div class="history-left-info">
              <p *ngIf="history.property">{{history.property}}</p>
              <p *ngIf="history.taskName">{{history.taskName}}</p>
              <p *ngIf="history.projectName">{{history.projectName}}</p>
            </div>
            <div>
              <svg-icon src='./assets/icons/checkmark-circle-outline.svg'
                        class="raci-icon raci-icon-bg-green svg-icon-white"
                        *ngIf="history.isApproved"></svg-icon>
              <svg-icon src='./assets/icons/close-circle-outline.svg'
                        class="raci-icon raci-icon-bg-red svg-icon-white" *ngIf="!history.isApproved"></svg-icon>
            </div>
            <div class="history-right-info">
              <p>{{history.userDescription}}</p>
              <p>{{history.comment}}</p>
            </div>
          </div>
          <div *ngIf="i < approval.historyRecords.length - 1" class="devide-vertical-line"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="scroll-box" *ngIf="task?.taskTypeId == taskTypes.ValoremFunction">
    <div class="history-block">
      <div *ngFor="let historyRecords of valoremHistory; index as i;">
        <div class="history-record">
          <div class="history-left-info">
            <p *ngIf="historyRecords.createdDate">{{historyRecords.createdDate | date: 'dd.MM.yyyy HH:mm'}}</p>
          </div>
          <div>
            <svg-icon src='./assets/icons/checkmark-circle-outline.svg'
                      class="raci-icon raci-icon-bg-green svg-icon-white"
                      *ngIf="historyRecords.isPublished"></svg-icon>
            <svg-icon src='./assets/icons/close-circle-outline.svg'
                      class="raci-icon raci-icon-bg-red svg-icon-white" *ngIf="!historyRecords.isPublished"></svg-icon>
          </div>
          <div class="history-right-info">
            <p>
              {{historyRecords.userDescription}}
            </p>
          </div>
        </div>
        <div *ngIf="i < valoremHistory.length - 1" class="devide-vertical-line"></div>
      </div>
      <div *ngIf="valoremHistory?.length == 0">
        {{ 'raci.approvalHistory.missingValoremHistory' | translate }}
      </div>
    </div>
  </div>
</div>
